<template>
	<v-layout align-center wrap class="record-filter-container">
		<v-flex xs6 md3 pr-2>
			<BaseSelect
				item-text="name"
				item-value="code"
				label="Nombre de Módulo"
				:height="38"
				:items="modules"
				v-model="moduleId"
				@input="$emit('filter', { modelName: 'moduleId', value: $event })"
			/>
		</v-flex>
		<v-flex xs6 md3 pl-2>
			<BaseSelect
				item-text="name"
				item-value="code"
				label="Estado"
				:items="states"
				:height="38"
				v-model="status"
				@input="$emit('filter', { modelName: 'status', value: $event })"
			/>
		</v-flex>
		<v-flex xs4 md2 pl-2 lg2>
			<app-date-select
				hide-details
				label="Fecha Inicial"
				:date-formatted="startDate"
				model="startDate"
				@input="$emit('filter', { modelName: 'startDate', value: $event })"
			/>
		</v-flex>
		<v-flex xs4 md2 pl-2 lg2>
			<app-date-select
				hide-details
				label="Fecha de Fin"
				:date-formatted="endDate"
				model="endDate"
				@input="$emit('filter', { modelName: 'endDate', value: $event })"
			/>
			</v-flex>
		<v-flex xs3 md2 sm4>
			<v-layout row>
				<v-flex pt-3 ml-3>
					<v-btn
						:disabled="!moduleId || !startDate || !endDate" 
						color="blue"
						class="ma-0 btn-action bd-radius btn-record"
						@click="$emit('search-record')">
						Buscar
					</v-btn>
				</v-flex>
				<v-flex pt-3 ml-3>
					<v-btn
						color="red"
						class="ma-0 btn-action bd-radius bg-red btn-record"
						@click="$emit('clean')"
					>
						Limpiar
					</v-btn>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	import appDateSelect from '@/components/shared/app-date-select';
	import { format, subDays } from 'date-fns';

	function created() {
		this.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.endDate = this.$today;
	}

	function cleanFilters(value) {
		if (value) {
			this.moduleId = null;
			this.status = null;
		}
	}

	function data() {
		return {
			moduleId: null,
			startDate: null,
			states: [
				{ id: 1, name: 'Contabilizado', code: 1 },
				{ id: 0, name: 'Pendiente', code: 0 },
			],
			status: null,
			endDate: null,
		};
	}

	export default {
		name: 'record-filter',
		components: {
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
			appDateSelect,
		},
		created,
		data,
		props: {
			cleanFilters: {
				default: false,
				type: Boolean,
			},
			modules: {
				default: () => [],
				type: Array,
			},
		},
		watch: {
			cleanFilters,
		},
	};
</script>
<style lang="scss" scoped>
	.record-filter-container {
		padding: 15px 40px 0;

		@media (max-width: 768px) {
			padding: 15px 10px 0
		}
	}

	.bd-radius {
		border-radius: 24px !important;
	}

	.btn-record {
		font-family: map-get($fonts, AvenirDemi) !important;
		font-size: 12px !important;
		width: 80px !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/records/record-filter.vue